module.exports = __webpack_public_path__ + "static/Vladik-Khononov.187ed50d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/speakers/Vladik-Khononov.jpg
// module id = 122
// module chunks = 40124410918716 240012292094641